import React from 'react'

export const useAllBrandAccountsQueryKey = () =>
  React.useMemo(() => ['UseAllBrandAccountsQuery_Main'], [])
